import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CONSTANTS } from 'src/app/core/constants/constants';
import { PERMISSIONS } from 'src/app/core/constants/permissions';
import { ShareModifications } from 'src/app/modules/dashboard/sheet/modules/list/components/share-modal/share-modifications.model';
import { API } from '../../../constants/api';
import { ConsentData } from '../../../models/consent-data.model';
import { RolesService } from '../../roles/roles.service';
import { StorageService } from '../../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(
    private httpClient: HttpClient,
    private storageService: StorageService,
    private rolesService: RolesService,
  ) {}

  getConsentsForDatasheet(datasheetId: number): Observable<ConsentData> {
    const urlToGet = `${API.DOCUMENTS_STORAGE}/${datasheetId}/consents`;
    return this.httpClient
      .get<ConsentData>(urlToGet)
      .pipe(catchError((error) => throwError(error)));
  }

  sendModifications(datasheetId: number, modifications: ShareModifications): Observable<any> {
    const urlToPost = `${API.DOCUMENTS_STORAGE}/${datasheetId}/share`;
    return this.httpClient
      .post(urlToPost, modifications)
      .pipe(catchError((error) => throwError(error)));
  }

  setCurrentPermissions(permissions: string[]): void {
    this.storageService.set(CONSTANTS.STORAGE.PERMISSIONS, permissions);
  }

  hasPermission(permission: string): boolean {
    const permissions: string[] = this.storageService.get(CONSTANTS.STORAGE.PERMISSIONS);
    return permissions?.filter((x) => x === permission)?.length > 0;
  }

  canEdit(): boolean {
    return (
      this.rolesService.isAdmin() ||
      this.hasPermission(PERMISSIONS.EDITOR) ||
      this.hasPermission(PERMISSIONS.CREATOR)
    );
  }
}
